import { render, staticRenderFns } from "./CustomerDatatable.vue?vue&type=template&id=374f312d&scoped=true"
import script from "./CustomerDatatable.vue?vue&type=script&lang=js"
export * from "./CustomerDatatable.vue?vue&type=script&lang=js"
import style0 from "./CustomerDatatable.vue?vue&type=style&index=0&id=374f312d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f312d",
  null
  
)

export default component.exports